import useIsMounted from 'app/hooks/useIsMounted';
import { useState } from 'react';
import { Input, useToasts } from 'tombac';
import { useAddOrganizationMutation } from "../api/organizationsApiHooks";
import { OrganizationPopupForm } from "./OrganizationShared";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrganizationAddForm({
  nameInputProps,
  onAdd,
  parentOrg,
  ...rest
}) {
  const mounted = useIsMounted();
  const {
    addToast
  } = useToasts();
  const {
    mutateAsync: addOrganization
  } = useAddOrganizationMutation();
  const [name, setName] = useState('');
  const [adding, setAdding] = useState(false);
  const handleSubmit = async event => {
    event.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) return;
    setAdding(true);
    try {
      await addOrganization({
        organization: {
          name,
          parentId: parentOrg.id
        }
      });
      if (mounted.current && onAdd) onAdd();
    } catch (error) {
      console.error(error);
      addToast(error?.message || 'Failed to save organization', 'danger');
    }
    if (mounted.current) setAdding(false);
  };
  return /*#__PURE__*/_jsx(OrganizationPopupForm, {
    onSubmit: handleSubmit,
    ...rest,
    "data-sentry-element": "OrganizationPopupForm",
    "data-sentry-component": "OrganizationAddForm",
    "data-sentry-source-file": "OrganizationAddForm.tsx",
    children: /*#__PURE__*/_jsx(Input, {
      autoFocus: true,
      disabled: adding,
      onChange: event => setName(event.target.value),
      placeholder: "New organization name",
      type: "text",
      value: name,
      $w: "30sp",
      ...nameInputProps,
      "data-sentry-element": "Input",
      "data-sentry-source-file": "OrganizationAddForm.tsx",
      "data-sentry-element": "Input"
    })
  });
}